import {createSelector} from "reselect";

const MotorcycleSelector = (state) => state.motorcyclist

export const getFinalForm = createSelector(MotorcycleSelector,state => state.finalForm)

